// @flow

import React from 'react';
import 'react-tippy-without-bugs/dist/tippy.css';

import { injectGlobal } from 'styled-components';
import reset from 'styled-reset';
import Topbar from '../Topbar';

injectGlobal`
  ${reset};

  html {
    color: #333;
    -webkit-font-smoothing: antialiased;
  }

  body {
    overflow-y: scroll;
    padding-top: 36px;
  }

  html,
  input,
  select,
  button {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  strong {
    font-weight: bold;
  }

  p {
    margin-bottom: 25px;
    line-height: 1.4;
  }

  a {
    text-decoration: none;
  }

  .overflow-hidden {
    overflow: hidden;

    @media(min-width: 740px) {
      overflow: auto;
    }

  }
`;

type Props = {
  children?: any,
};

const Layout = (props: Props) => (
  <>
    <Topbar />
    {props.children}
  </>
);

export default Layout;
